import { render, staticRenderFns } from "./carousel-version.vue?vue&type=template&id=6876f2b0&scoped=true&"
import script from "./carousel-version.vue?vue&type=script&lang=js&"
export * from "./carousel-version.vue?vue&type=script&lang=js&"
import style0 from "./carousel-version.vue?vue&type=style&index=0&id=6876f2b0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6876f2b0",
  null
  
)

export default component.exports